import { compose } from 'redux'
import { withHandlers, withProps } from 'recompose'
import { show } from 'redux-modal'
import withType from 'components/common/hoc/withType'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { withRouter } from 'react-router-dom'
import BOTArticleCategories from './BOTArticleCategories'
import { connect } from 'react-redux'
import { ARTICLES_ACCORDION_MODAL } from './constants'

const withArticleCategoriesHandlers = withHandlers({
  moveToFeaturedArticle: ({
    history,
    articleCategory: {
      mostPopularAtricle
    }
  }) => () => {
    history.push(mostPopularAtricle.articleURL)
  },
  showAccordionModal: ({
    show,
    articleCategory: {
      articleCategories
    }}) => () => {
    show(ARTICLES_ACCORDION_MODAL, { articleCategories })
  }
})

export default compose(
  withType({ type: 'BOTArticleCategories' }),
  connect(null, { show }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withRouter,
  withArticleCategoriesHandlers
)(BOTArticleCategories)
